/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const FeatherRegularV6 = (props) => (
  <Icon {...props} name="Feather Regular V6">
    <path d="M14.597 1.402C13.697.5 12.553 0 11.303 0 9.842 0 8.24.684 6.712 2.207L4.034 4.884c-2.343 2.348-2.257 6.138-1.758 7.778L.218 14.717a.751.751 0 0 0 1.062 1.062l2.051-2.051c.543.164 1.324.286 2.214.286 1.785 0 3.972-.486 5.566-2.049l2.68-2.68c2.805-2.83 2.758-5.927.805-7.885zM4.606 12.456l1.457-1.457H9.91c-1.391 1.308-3.334 1.516-4.391 1.516a7.572 7.572 0 0 1-.913-.059zm6.35-2.484H7.062L9.034 8H12.9c-.07.074-.097.152-.199.227l-1.745 1.745zm2.76-3h-3.653l.703-.703c.293-.293.293-.769 0-1.034-.293-.293-.769-.293-1.034 0l-6.128 6.128C3.44 9.93 3.596 7.482 5.151 5.922L7.83 3.243c1.128-1.128 2.375-1.769 3.528-1.769.832 0 1.605.336 2.234.965 1.165 1.222 1.193 2.909.124 4.534z" />
  </Icon>
);

export default FeatherRegularV6;
